import React from "react"
import styled from "@emotion/styled"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Container = styled.div`
  padding: 64px 32px;
  border-radius: 16px;
  background: ${props => props.theme.shade[100]};
  ul {
    list-style: none;
    margin: 0;
    li {
      margin-bottom: 4px;
    }
  }
`
const CustomIcon = styled(FontAwesomeIcon)`
  margin-bottom: 32px;
  color: ${props => props.theme.primary};
`

export default function Card({ title, icon, children }) {
  return (
    <Container>
      <CustomIcon icon={icon} size="2x" />
      <h3>{title}</h3>
      {children}
    </Container>
  )
}
